import { Timestamp } from "firebase/firestore";

export type Vertical =
  | "tech"
  | "culture"
  | "gaming"
  | "music"
  | "film"
  | "fashion"
  | "health"
  | "general";

export type EventItemType =
  | "knowledge"
  | "financial"
  | "social"
  | "entertainment";

export const verticalToStringMap: Record<string, Vertical> = {
  General: "general",
  Gaming: "gaming",
  Music: "music",
  Tech: "tech",
  Fashion: "fashion",
  Culture: "culture",
  Film: "film",
  Health: "health",
};

export const eventItemTypeToStringMap: Record<string, EventItemType> = {
  Knowledge: "knowledge",
  Financial: "financial",
  Social: "social",
  Entertainment: "entertainment",
};

export interface EventCheckIn {
  isAlreadyCheckedIn: boolean;
  lastScannedAt?: Timestamp;
  eventId: string;
  userId: string;
  timestamp: Date;
  eventName?: string;
  name?: string;
  email?: string;
  passType?: string;
  passId?: string;
  status:  'ACCEPTED' | 'REJECTED';
}

export interface EventItem {
  id: string;
  title: string;
  description: string;
  endTime: Timestamp;
  startTime: Timestamp;
  vertical: Vertical;
  type?: EventItemType;
  lastModified?: Timestamp;
  location: string;
  locationId?: string;
  banner?: string;
  bannerPath?: string;
  isCanceled?: boolean;
  tags?: string[];
  updatedBy?: {
    uid: string;
    name: string;
  };
  /** Speaker IDs associated with this event */
  speakers?: string[];
  /** If true, this event is featured on its vertical page */
  isFeatured?: boolean;
  /** Preview events (e.g., film preview) */
  isPreview?: boolean;
  /** Sort order for featured events (lower = first) */
  featuredOrder?: number;
  /** Festival year (e.g., 2025) */
  festivalYear?: number;
  /** Event sessions for multi-session events */
  sessions?: EventSession[];
}

export interface EventSession {
  id: string;
  title: string;
  startTime: Timestamp;
  endTime: Timestamp;
  /** Can override parent event venue */
  venue?: string;
  /** Session-specific speakers */
  speakers?: string[];
}

export interface MySchedule {
  id: string;
  timestamp: Date;
  vertical: string;
  lastModified: Date;
}

export interface EditEventModel
  extends Omit<EventItem, "startTime" | "endTime" | "id"> {
  startTime: string;
  endTime: string;
  eventDate: string;
  doesUserReceiveNotification: string;
  doesUserReceiveNotificationForCancle: string;
}
